// extracted by mini-css-extract-plugin
export default {"groupTitle":"ReportsGroupBody_groupTitle__fz8XA","groupTotal":"ReportsGroupBody_groupTotal__p5dAl","groupBody":"ReportsGroupBody_groupBody__RVjUg"};